var handleError = function (err) {
  console.log(err);
  return new Response(JSON.stringify({
    code: 400,
    message: 'Stupid network Error'
  }));
};

export default function getAdditionalDisplayLayers(sState, companyType, sDispatch) {
    
    const abortController = new AbortController();

      //console.log("uid: "+sState.userid+", aid:"+sState.aid+", geom:"+sState.datageom.area);
      const request = {
        userid: sState.userid,
        accountid: sState.aid,
        ident: sState.ident,
        companytype: companyType
      }

      let mounted = true;
      (async () => {
        const res = await fetch(process.env.REACT_APP_FIND_API+'/mapping/display?userid='+sState.userid+'&accountid='+sState.aid+'&ident='+sState.ident+'&companytype='+companyType, {
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            signal: abortController.signal,
          }).catch(handleError);
        const data = await res.json();
        if (mounted) {
          if (data.status === "success"){
            sDispatch({
              type: "setDataLayerList",
              payload: { layers : data.data}
            });
          }
        }
      })();
      const cleanup = () => {
         mounted = false;
         abortController.abort();
      };
      return cleanup;
}